// extracted by mini-css-extract-plugin
export default {"disbursement-container":"WJdLi","name-input":"jonBc","amount-input":"byUDu","vat-label":"mVyzR"};